/** Dismissable activatiemelding bovenaan Vandaag (register B). */
import { Alert, Button } from '@mui/material';
import { useT } from '@/i18n/useT';

/**
 * @param {Object} props
 * @param {number} props.completedCount
 * @param {() => void} props.onDismiss
 */
const ActivationNoticeBanner = ({ completedCount, onDismiss }) => {
  const t = useT();
  const messageKey =
    completedCount === 1
      ? 'activationnotice.completedSingular'
      : 'activationnotice.completedPlural';

  return (
    <Alert
      data-testid="activation-notice-banner"
      role="status"
      severity="success"
      sx={{ mb: 2 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={onDismiss}
          aria-label={t('activationnotice.dismiss', 'Sluiten')}
        >
          {t('activationnotice.dismiss', 'Sluiten')}
        </Button>
      }
    >
      {t(messageKey, '{count} taken voltooid sinds je begon. Goed op weg!', {
        count: completedCount,
      })}
    </Alert>
  );
};

export default ActivationNoticeBanner;
